import client from './client'

export const login = (data) => client.post('/auth/login', data)
export const register = (data) => client.post('/auth/register', data)
export const verifyEmail = (token) => client.get(`/auth/verify-email?token=${token}`)
export const forgotPassword = (email) => client.post('/auth/forgot-password', { email })
export const resetPassword = (token, password) => client.post('/auth/reset-password', { token, password })
export const changePassword = (data) => client.post('/auth/change-password', data)
export const telegramLogin = (payload) => client.post('/auth/telegram', payload)
export const acceptPolicies = (data) => client.post('/auth/accept-policies', data)
export const getCurrentUser = () => client.get('/auth/me')